import { MailDomain } from "../../../lib/src/api/partner/models/MailDomain";
import { useApiClient } from "../../../lib/src/api";
import { config } from "../config";
import { FC, useCallback, useState } from "react";
import { useRefresh } from "../../../lib/src/components/RefreshController";
import { useNavigate } from "react-router-dom";
import { ModalFooter } from "../../../lib/src/components/layout/ModalProvider";
import { Input } from "../../../lib/src/components/form/Input";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";

export const EditMailUserModal: FC<{ domain: MailDomain, email: string }> = ({ domain, email }) => {
  const { partnerClient } = useApiClient(config)
  const reload = useRefresh()
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!



  const save = useCallback(async () => {
    const deployment = await partnerClient.resetPasswordFromUser(domain.id, email, password).then(result => {
      if (!result.success) {
        setError(result.error)
        throw new Error(result.error)
      }
      return result.data
    })
    if (deployment.entityId) {
      await awaitNextDeploymentFinished(deployment.entityId)
    }
    reload()
    navigate(`/mail/${domain.id}`)
  }, [domain, email, password])

  return <>
    <form onSubmit={() => save()} className={"space-y-4 flex-1"}>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Input label={'New password'} type={"password"} value={password} onChange={setPassword} />
      </div>
      {error.length > 0 && <div className={"font-medium text-red-600"}>
        {error}
      </div>}
    </form>
    <ModalFooter text={"Save"} onSubmit={save} />
  </>
}
